var shop_currency_default = $('#shop_currency_val').text();
function myCartSection() {
  var SideContentHeight = $('.cart-side-panel .block-cart-header').height();
  $('#cart_container_id').css('top', SideContentHeight + 'px');  
}

function trending_slider(){
  $('#cart_modal_popup .page_trending').slick({
    slidesToShow: 3,slidesToScroll: 3,autoplay: false,arrow:false,autoplaySpeed: 2000,slide:'li',dots: true,infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true, variableWidth: true
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true, variableWidth: true
        }
      }
    ]
  }); 
}


jQuery(window).resize(function(){
  myCartSection();
});
var shop_currency;
if(typeof $.cookie('currency') === 'undefined'){
  shop_currency = shop_currency_default;
} else{
  shop_currency = $.cookie('currency');
}
var wc_theme_source = {
  lib:{
    ajax_error: function(error, message, this_click){

      var data = eval('('+error.responseText+')');
      //console.log('data : ' . data);
      if(!!data.message){        
        if(this_click == 'grid_click'){          
          var itrmCount = data.description.split(' ')[1];
          jQuery('.cartCount_item').text(itrmCount);
          jQuery('#cart_error_message').find('h5').text(data.description);         
          setTimeout(function(){
            $("#cart_modal_popup.in").css('opacity','0');
            $("#cart_error_message").modal('show');
          },500);         
        }
        else{
          jQuery('.responseJSON_Error').find('h5').text(data.description);
          jQuery('.responseJSON_Error').show();
        }
      }
    },
    on_cart_update: function(item){
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart){          
          if(cart.item_count > 0){
            var upsell_html = '';
            $.each(cart.items, function(index, item){
              var cart_handle = item.handle;
              var storage_val = localStorage[cart_handle];
              if(typeof storage_val != 'undefined'){
                if(storage_val != ''){
                  upsell_html += storage_val;
                }
              }
              if(index === (cart.items.length - 1)){
                if(upsell_html != ''){
                  $('#wc_cart_drawer_upsell').html(upsell_html);
                } else{
                  $('.upsell_content').attr('style', 'display:none !important;');
                }
              }
            });
          }

          $('.cart_qty_cls').html(cart.item_count);          
          var shop_currency = '';
          //jQuery('.shop_cart span.title span').html(Shopify.formatMoney(cart.total_price, shop_currency));

          var shipping_price = parseFloat();
          var total_price = Shopify.formatMoney(cart.total_price, shop_currency_default).replace(/[^\d\.]/g, '');
          var remaining_value = parseFloat(shipping_price) - parseFloat(total_price);
          var final_value = remaining_value.toFixed(2);			
          if(final_value < 0){   
            $('.free_shipping').css('display','inline-block');
            $('.notFree_shipping').hide();    
          } else{    
            $('.remaining_value').text('$'+final_value);
            $('.notFree_shipping').css('display','inline-block');
            $('.free_shipping').hide();   
          }
          if(cart.item_count > 0){
            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            if($('.items_carts span').hasClass('money')){
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            } else{
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            }
          } else{
            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            $('.items_carts span').remove();
            $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
          }
          setTimeout(function(){
            myCartSection();
            trending_slider();
          },600);
        });
      },100);
    },
    on_item_added: function(item,popup){

      
      //wc_theme_source.lib.on_cart_update(item);
      ajaxCart.load();
      setTimeout(function(){
        if (item.quantity === 1) {
          jQuery('.c_item_quantity').text('an');
        }else{
          jQuery('.c_item_quantity').text(item.quantity);
          // console.log(item.quantity);
        }

        $(".coll_pro_featured").each(function( index ) {
          var product_count = $(this).find('ul.wc_pro_slider li').size();
          if (product_count == 0){
            $(this).remove();
          }
        });
        if(popup == true){
          $('#upsell-product').modal('show');
        }
        trending_slider();


      },1500);
    },
    on_product: function(e){
      alert("Received everything we ever wanted to know about " + e.title);
    },
    addtocart_product: function(id, qty, callback,this_click){
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function(item){
          if(window.location.href.indexOf("/cart") > -1){
            location.reload();
          } else{
            if((typeof callback) === 'function'){
              callback(item, id);
            } else{
              wc_theme_source.lib.on_item_added(item,'');
            }
            setTimeout(function(){
              
              $('#close_quickview_popup').trigger( "click" );
              $('body').addClass('CartOpen');
              
            },500);           
          }
        },
        error: function(XMLHttpRequest, textStatus){
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
          }
        }
      };
      jQuery.ajax(ajax);
    },
    get_product: function(handle, callback){
      jQuery.getJSON("/products/" + handle + ".js", function(product, n){
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function(callback){
      jQuery.getJSON("/cart.js", function(cart, textstatus){
        if((typeof callback) === 'function'){
          callback(cart);
        } else{
          wc_theme_source.lib.on_cart_update(cart);         
        }
      });
    },
    addtocart_form: function(form_id, callback, errorCallback, this_click, popup){
      var ajax = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        beforeSend: function(){
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, form_id);
          } else{
            wc_theme_source.lib.on_item_added(item,popup);
          }
          setTimeout(function(){
            
              $('#close_quickview_popup').trigger( "click" );
              $('body').addClass('CartOpen');
            
          },500);
        },
        error: function(XMLHttpRequest, textStatus){
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
          }
        }
      };
      jQuery.ajax(ajax);
    },
    addtocart_fbt: function(variant_ids, callback, errorCallback, this_click){
      for (var i = 0; i < variant_ids.length; i++)
      {
        (function(i){
          setTimeout(function(){
            console.log(variant_ids[i]);
            var productVariant = variant_ids[i];
            var ajax = {
              type: 'POST',
              url: '/cart/add.js',
              data: 'quantity='+1+'&id='+productVariant,
              dataType: 'json',
              success: function(line_item) {
                if((typeof callback) === 'function'){
                  callback(line_item, variant_ids);
                } else{
                  wc_theme_source.lib.on_item_added(line_item,'');
                }
                console.log("success! - "+line_item.title);
                console.log('---'+i+'-----');
                var iteration_length = i+1;
                //if iteration length is equal to the total length - it means that we have
                //reached the last item. Now we redirect to cart or may be show pop up
                if( iteration_length == variant_ids.length ){ 
                  //redirect to cart or 
                  //document.location.href = '/cart'; 
                  //do whatever
                  setTimeout(function(){
                    
                    $('#close_quickview_popup').trigger( "click" );
                    $('body').addClass('CartOpen');
                    
                  },500); 
                }
              },
            error: function() {
            console.log("fail");
            }
            };
            jQuery.ajax(ajax);
          }, 1000 * i);

        }(i));
      }
    },
    addtocart_upsell: function(variant_ids, callback, errorCallback, this_click, popup, thiss){
      for (var i = 0; i < variant_ids.length; i++)
      {
        (function(i){
          setTimeout(function(){
            console.log(variant_ids[i]);
            var productVariant = variant_ids[i];
            var ajax = {
              type: 'POST',
              url: '/cart/add.js',
              data: 'quantity='+1+'&id='+productVariant,
              dataType: 'json',
              success: function(line_item) {
                if((typeof callback) === 'function'){
                  callback(line_item, variant_ids);
                } else{
                  wc_theme_source.lib.on_item_added(line_item,popup);
                }
                

              var iteration_length = i+1;
              //if iteration length is equal to the total length - it means that we have
              //reached the last item. Now we redirect to cart or may be show pop up
              if( iteration_length == variant_ids.length ){ 
              //redirect to cart or 
              //document.location.href = '/cart'; 
              //do whatever
              setTimeout(function(){
                
                  $('#close_quickview_popup').trigger( "click" );
                  $('body').addClass('CartOpen');
                
                window.location.href = thiss.data('href');
              },500); 
            }
              },
              error: function() {
                console.log("fail");
              }
            };
            jQuery.ajax(ajax);
            }, 1000 * i);
          
        }(i));
      }
    },    

//     upsell_product: function(product_handle, callback, errorCallback, this_click){
//       var ajax = {
//         type: 'POST',
//         url: '/upsell-popup.liquid'
//         data: 'product_handle=' + product_handle
//       };
//       jQuery.ajax(ajax);
//     },
    
    
    cart_change_item: function(line, qty, callback){
      var ajax = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&line=' + line,
        dataType: 'json',
        success: function(cart){          
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          setTimeout(function(){ 
            FreeShippingBar();
          }, 2000);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
      setTimeout(function(){ 
        FreeShippingBar();
      }, 2000);
    },
    cart_remove_item: function(line, callback){
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function(){
          jQuery('.cart_loader_cls_id').show();
        },
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery('.cart_loader_cls_id').hide();
          setTimeout(function(){ 
            FreeShippingBar();
          }, 2000);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
      setTimeout(function(){ 
        FreeShippingBar();
      }, 2000);
    },
    cart_clear_all: function(){
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function(form){
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function(){
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    }
  }
}
jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
  var popup ='';
  if($(this).hasClass('upsell_product_trigger')){
    popup = true;
  }
  else{
    popup = false;
  }
  if( $('.line-item-property__field').length  > 0 ){
    if($('.line-item-property__field input').val() == "" ){
      if($('.error_msg').length < 1){
        $('.line-item-property__field').append('<p class="error_msg" style="color:red;">This field is required</p>');
      }
      $('.line-item-property__field input').css("border-color","red");
      return false;
    }
    else{
      $('.error_msg').remove();
      $('.line-item-property__field input').removeAttr('style');
    }
  }
  var this_click = $(this).data('click');
  var temp_form_id = jQuery(this).closest('form').attr('id');
  //alert(temp_form_id);
  //var product_handle = jQuery(this).data('handle')
  wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click, popup);
  //wc_theme_source.lib.upsell_product(product_handle, '', '', this_click);
  return false;
});

jQuery(document).on('click', '.add_to_cart_fbt', function(){
  var this_click = $(this).data('click');  

  var variant_ids = new Array();
  $("select[name='SelectId']").each(function(){
    var selecttrue = $(this).is(':enabled');
    if(selecttrue == true)
    {
    var selected_variant_id = $(this).children("option:selected").val();
    variant_ids.push(selected_variant_id); 
    }
  });
  //console.log(variant_ids);
  wc_theme_source.lib.addtocart_fbt(variant_ids, '', '', this_click);
  return false;
});

jQuery(document).on('click', '#btn-upsell', function(){
  var this_click = $(this).data('click');
  var thiss = $(this);
  var variant_ids = new Array();
  var selected_variant_id =  $(this).parents('form').find('select').children("option:selected").val();
  //console.log('selected_variant_id : '  + selected_variant_id);
	
  var temp_qty = 1;
  variant_ids.push(selected_variant_id);   
  console.log('vatr_id : '  + variant_ids);
//     $('#upsell-product').modal('show');
  var popup = 'up_popup';
  wc_theme_source.lib.addtocart_upsell(variant_ids, temp_qty, 'function', this_click, popup, thiss);

  return false;
});

jQuery(document).on('click', '.cart_add_btn', function(){
  var this_click = $(this).data('click');
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = 1;
  wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
  return false;
});


jQuery('.wishlist_add_btn_cls').click(function(){
  var temp_form_id = jQuery(this).closest('form').attr('id');
  var remove_var = jQuery(this).parents('.cartItem').find('.remove_btn_wislist');
  wc_theme_source.lib.addtocart_form(temp_form_id, 'null');
  return false;
});

jQuery(document).ready(function(){
  ajaxCart.load();
  $('#cart_error_message').on('hidden.bs.modal', function () {
    $("#cart_modal_popup.in").css('opacity','1');
  });
});	